import type { IntervalGridRecord } from "@/services/interval"
import { PERIOD_DATE_TIME_FORMAT } from "@/utils/date"
import { useFlowDirectionColumn } from "@/utils/grid-columns/use-flow-direction-column"
import { useMeterCodeColumn } from "@/utils/grid-columns/use-meter-code-column"
import { usePeriodColumn } from "@/utils/grid-columns/use-period-column"
import { useTimezoneColumn } from "@/utils/grid-columns/use-timezone-column"
import { useUsageColumn } from "@/utils/grid-columns/use-usage-column"
import { useUtilityProviderColumn } from "@/utils/grid-columns/use-utility-provider-column"

import type { GridColDef } from "@mui/x-data-grid-pro"

interface UseIntervalRecordsGridColumnsOptions {
  showFlowDirection: boolean
  timeZone: string
}

export const useIntervalRecordsGridColumns = ({
  showFlowDirection,
  timeZone,
}: UseIntervalRecordsGridColumnsOptions): GridColDef<IntervalGridRecord>[] => {
  const flowDirectionColumn = useFlowDirectionColumn<IntervalGridRecord>()
  const meterCodeColumn = useMeterCodeColumn<IntervalGridRecord>()
  const periodColumn = usePeriodColumn<IntervalGridRecord>({
    endField: "end_datetime",
    format: PERIOD_DATE_TIME_FORMAT,
    startField: "start_datetime",
    timeZone,
  })
  const timezoneColumn = useTimezoneColumn<IntervalGridRecord>({ timeZone })
  const usageColumn = useUsageColumn<IntervalGridRecord>({
    field: "value",
    precision: 2,
    unitField: "unit",
  })
  const utilityProviderColumn = useUtilityProviderColumn<IntervalGridRecord>()

  return [
    meterCodeColumn,
    utilityProviderColumn,
    periodColumn,
    timezoneColumn,
    {
      ...usageColumn,
      maxWidth: 180,
    },
    ...(showFlowDirection ? [flowDirectionColumn] : []),
  ]
}
